import React from 'react';
import { ClipboardList, Target, MessageCircle } from 'lucide-react';
import { coachImages } from '../../data/mock';

const steps = [
  {
    icon: ClipboardList,
    title: 'Apply',
    description: 'Answer a few questions about your goals and lifestyle.',
    step: '01'
  },
  {
    icon: Target,
    title: 'Get Your Plan',
    description: 'Receive customized training + nutrition built for you.',
    step: '02'
  },
  {
    icon: MessageCircle,
    title: 'Start Coaching',
    description: 'Weekly check-ins and ongoing support to keep you on track.',
    step: '03'
  }
];

const HowItWorks = () => {
  return (
    <section className="py-16 sm:py-24 bg-black">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 uppercase tracking-wider">
            How It Works
          </h2>
          <p className="text-white/50 text-sm sm:text-base max-w-md mx-auto">
            A simple process designed for real results
          </p>
        </div>

        {/* Content with Coach Image */}
        <div className="max-w-5xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          {/* Coach Image */}
          <div className="w-full max-w-xs lg:max-w-none lg:w-72 overflow-hidden border-2 border-white/30 flex-shrink-0">
            <img 
              src={coachImages.lifestyle} 
              alt="Ramzy - Ramzy Coaching"
              className="w-full aspect-[3/4] object-cover"
              data-testid="how-it-works-image"
            />
          </div>

          {/* Steps */}
          <div className="flex-1 space-y-4 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-4">
            {steps.map((step, index) => (
              <div 
                key={index}
                className="section-card relative group"
              >
                {/* Step Number Badge */}
                <div className="absolute -top-3 -right-2 w-10 h-10 bg-white flex items-center justify-center">
                  <span className="text-black text-sm font-bold">{step.step}</span>
                </div>

                {/* Icon */}
                <div className="w-12 h-12 bg-white/10 flex items-center justify-center mb-4">
                  <step.icon className="w-6 h-6 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-lg font-bold text-white mb-2 uppercase tracking-wider">{step.title}</h3>
                <p className="text-white/50 text-sm leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
